import { http } from './http';
import { ROUTES } from './config';
import type {
  DiscountRule,
  DiscountRuleInput,
  DiscountRuleAnalytics,
  DiscountValidation,
  DiscountCalculateItem,
  DiscountCalculation,
} from '../types/ecommerce';

/** DiscountsController client — the real checkout-time discount-rule engine (ProductService). */
export const discountsApi = {
  listRules(): Promise<DiscountRule[]> {
    return http.get(ROUTES.discounts.rules);
  },

  createRule(body: DiscountRuleInput): Promise<DiscountRule> {
    return http.post(ROUTES.discounts.rules, body);
  },

  updateRule(id: string, body: DiscountRuleInput): Promise<void> {
    return http.put(`${ROUTES.discounts.rules}/${id}`, body);
  },

  removeRule(id: string): Promise<void> {
    return http.delete(`${ROUTES.discounts.rules}/${id}`);
  },

  ruleAnalytics(id: string): Promise<DiscountRuleAnalytics> {
    return http.get(ROUTES.discounts.ruleAnalytics(id));
  },

  /** Anonymous — early feedback only (code exists + is currently running), not a discount amount. */
  validate(code: string): Promise<DiscountValidation> {
    return http.get(ROUTES.discounts.validate(code), { anonymous: true });
  },

  /** Read-only preview of the best-matching discount for a cart — same calculation OrderService
   * runs authoritatively at checkout, called here just so the cart page can show it in advance. */
  calculate(body: { customerId: string; items: DiscountCalculateItem[]; subtotal: number; code?: string | null }): Promise<DiscountCalculation> {
    return http.post(ROUTES.discounts.calculate, body);
  },
};
